import { render } from "./single-note-tab.vue?vue&type=template&id=9b73ca72&ts=true"
import script from "./single-note-tab.vue?vue&type=script&lang=ts"
export * from "./single-note-tab.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__